import {post} from '@/utils/request';
import {smcanteenserver} from '@/utils/baseUrl';
//用户明细
export async function getList(params) {
    return post(smcanteenserver+'/account/getList', params, true)
}
export async function getDetailList(params) {
    return post(smcanteenserver+'/account/getDetailList', params, true)
}